import { useContext } from 'react';
import { ViewCheckbookContext } from 'src/sections/view_checkbook/ViewCheckbookContext';

const useViewCheckbook = () => {
  const context = useContext(ViewCheckbookContext);
  if (!context)
    throw new Error('View Checkbook context must be used inside ViewCheckbookContextProvider');
  return context;
};

export default useViewCheckbook;
